<div class="unity-form-group toggle-switch {{ classes }} {{ disabled ? 'disabled' : '' }}">
  <div class="unity-form-row">
    <label for="{{ inputId }}">
      <input
        type="checkbox"
        id="{{ inputId }}"
        [checked]="isChecked"
        [disabled]="disabled"
        (change)="onCheckboxChange($event)"
      />
      <span class="dot"></span>
      {{ label }}
    </label>
    <!-- <svg class="unity-form-status-icon unity-icon unity-icon-checkmark">
      <use xlink:href="#unity-icon-checkmark"></use>
    </svg> -->
  </div>
</div>
